module.exports = __webpack_public_path__ + "post-listing-block-3-overlay-3qAlh76.png";